import { Directive, HostListener, ElementRef, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
  selector: '[appEnglishToCyrillic]',
  standalone:true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EnglishToCyrillicDirective),
      multi: true
    }
  ]
})
export class EnglishToCyrillicDirective implements ControlValueAccessor{

private onChange = (_: any) => {};
  private onTouched = () => {};

  constructor(private el: ElementRef) {}

  writeValue(value: any): void {
    const converted = this.convertToCyrillic(value || '');
    this.el.nativeElement.value = converted;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  @HostListener('input', ['$event.target.value'])
  onInput(value: string): void {
    const converted = this.convertToCyrillic(value);
    this.el.nativeElement.value = converted;
    this.onChange(converted);
  }
  @Input('appEnglishToCyrillic') set text(value: string) {
    this.el.nativeElement.textContent = this.convertToCyrillic(value || '');
  }

  private latinToCyrillicMap: { [key: string]: string } = {
    'a': 'а', 'A': 'А',
    'b': 'б', 'B': 'Б',
    'v': 'в', 'V': 'В',
    'g': 'г', 'G': 'Г',
    'd': 'д', 'D': 'Д',
    'e': 'е', 'E': 'Е',
    'zh': 'ж', 'Zh': 'Ж',
    'z': 'з', 'Z': 'З',
    'i': 'и', 'I': 'И',
    'k': 'к', 'K': 'К',
    'l': 'л', 'L': 'Л',
    'm': 'м', 'M': 'М',
    'n': 'н', 'N': 'Н',
    'o': 'о', 'O': 'О',
    'p': 'п', 'P': 'П',
    'r': 'р', 'R': 'Р',
    's': 'с', 'S': 'С',
    't': 'т', 'T': 'Т',
    'u': 'у', 'U': 'У',
    'f': 'ф', 'F': 'Ф',
    'h': 'х', 'H': 'Х',
    'ts': 'ц', 'Ts': 'Ц',
    'ch': 'ч', 'Ch': 'Ч',
    'sh': 'ш', 'Sh': 'Ш',
    'lj': 'љ', 'Lj': 'Љ',
    'nj': 'њ', 'Nj': 'Њ',
    'dž': 'џ', 'Dž': 'Џ',
    'j': 'ј', 'J': 'Ј',
    'q': 'љ', 'Q': 'Љ',
    'w': 'њ', 'W': 'Њ',
    '[': 'ш', ';': 'ч',
    ']': 'ѓ', "'": "ќ",
    'y':'ѕ' , 'Y': 'Ѕ',
    'x':'џ' , 'X': 'Џ'
};

 

  // @HostListener('input', ['$event'])
  // onInput(event: Event): void {
  //     const inputElement = this.el.nativeElement as HTMLInputElement;
  //     const originalValue = inputElement.value;
  //     const newValue = this.convertToCyrillic(originalValue);
  
  //     if (newValue !== originalValue) {
  //         inputElement.value = newValue;
  //         inputElement.dispatchEvent(new Event('input', { bubbles: true }));
  //     }
  // }

  private convertToCyrillic(text: string): string {
    let cyrillicText = '';
    for (const char of text) {
      cyrillicText += this.latinToCyrillicMap[char] || char; 
    }
    return cyrillicText;
  }
}
